<!--  -->
<template>
  <div :class="this.yiying?'header header1':'header'">
    <div class="header-a">
      <div class="header-tu">
        <a href=""><img src="../assets/image/logo.png" alt /></a>
      </div>
      <div class="header-zi">
        <img src="../assets/image/slogan.png" alt />
      </div>
      <div class="header-nav">
        <ul>
          <router-link to="/home">
            <li>首页</li>
          </router-link>
          <router-link to="/product">
            <li class="chanpin">
              产品
              <!-- <ol>
                <li @click="lista11(1)">
                  <span :class="lista1==1?'active1':''">零售版</span>
                </li>
                <li @click="lista12(2)">
                  <span :class="lista1==2?'active1':''">分销版</span>
                </li>
              </ol>-->
             

              <ol>
                <router-link to="/product">
                  <li>
                    <span>零售版</span>
                  </li>
                </router-link>
                <router-link to="/product/products2">
                  <li>
                    <span>分销版</span>
                  </li>
                </router-link>
              </ol>
              
            </li>
          </router-link>
          <router-link to="/service">
            <li>服务</li>
          </router-link>
          <router-link to="/price">
            <li>价格</li>
          </router-link>
          <router-link to="/about">
            <li>关于我们</li>
          </router-link>
          <!-- <a href="https://www.zolerp.cn/aboutus.html"><li>关于我们</li></a> -->
        </ul>
      </div>
      <div class="header-loig">
        <a href="https://erp.yserp.cc/login.html#/">
          <samp>登录</samp>
        </a>
        <a href="https://erp.yserp.cc/register.html#/">
          <button>免费注册</button>
        </a>
      </div>
    </div>
  </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';

export default {
  //import引入的组件需要注入到对象中才能使用
  components: {},
  data() {
    //这里存放数据
    return {
      lista1: 1,
      yiying:false,
    };
  },
  //监听属性 类似于data概念
  computed: {},
  //监控data中的数据变化
  watch: {},
  //方法集合
  methods: {
    lista11(v) {
      this.lista1 = v;
      this.$emit("myevent", this.lista1);
    },
    lista12(v) {
      //$emit()
      //第一个参数自定义的事件
      //第二个参数传递的数据，如果数据有多个，可以写成数组或对象的形式
      // console.log(this)
      this.lista1 = v;
      this.$emit("myevent", this.lista1);
    },
      handleScroll() {
        let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
        // console.log(scrollTop>200)
        if(scrollTop>200){
          this.yiying=true
          // console.log('大于')
        }else{
          this.yiying=false
          // console.log('小于')
        }
      }
  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {},
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {
    window.addEventListener('scroll', this.handleScroll)
  },
  beforeCreate() {}, //生命周期 - 创建之前
  beforeMount() {}, //生命周期 - 挂载之前
  beforeUpdate() {}, //生命周期 - 更新之前
  updated() {}, //生命周期 - 更新之后
  beforeDestroy() {}, //生命周期 - 销毁之前
  destroyed() {}, //生命周期 - 销毁完成
  activated() {}, //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style lang='less' scoped>
//@import url(); 引入公共css类
// .router-link-active {
//   color: #3366ff;
// }

a {
  color: #333333;
}

.chanpin {
  ol {
    position: relative;
    left: 0%;
    top: 0%;
    // display: none;
    width: 76px !important;
    height: 0px;
    overflow: hidden;
    list-style: none;
    // background-color: red;
    transition: width 0.6s ease 0s, height 0.3s ease-in 0s;
    
    li {
      background-color: #ffffff;
      color: #333333;
      width: 76px !important;
      height: 40px !important;
      line-height: 40px !important;
    }
    .router-link-exact-active li{
      color: #3366ff;
    }
  }
}
.active1 {
  color: #3366ff !important;
}
.chanpin:hover ol {
  height: 80px;
  display: block;
}
.chanpin ol li:hover {
  background-color: #eaeaea;
}


.header {
  // border: 1px solid red;
  width: 100%;
  height: 76px;
  background-color: #ffffff;
  position: fixed; z-index: 9999;
  top: 0;
  
  .header-a {
    width: 1200px;
    // border: 1px solid red;
    height: 76px;
    margin: 0 auto;
    .header-tu {
      width: 142px;
      height: 46px;
      margin-top: 15px;
      margin-right: 22px;
      float: left;
      img {
        width: 100%;
      }
    }
    .header-zi {
      width: 182px;
      height: 18px;
      margin-top: 30px;
      float: left;
      img {
        width: 100%;
      }
    }
    .header-nav {
      // border: 1px solid red;
      width: 380px;
      height: 76px;
      float: left;
      margin-left: 74px;
      ul {
        list-style: none;
        li {
          width: 76px;
          height: 76px;
          float: left;
          line-height: 76px;
          text-align: center;
          &:hover{
            color: #3366ff;
          }
        }
        .ali {
          color: #3366ff;
        }
      }
    }
    .header-loig {
      width: 165px;
      height: 76px;
      float: right;
      a {
        samp {
          margin-top: 23px;
          line-height: 30px;
          width: 80px;
          height: 30px;
          color: #333333;
          display: inline-block;
          text-align: center;
          background-color: white;
          transition: background 1s;
        }
        button {
          width: 80px;
          height: 30px;
          background-color: #3366ff;
          border: 0px;
          margin-top: 23px;
          float: right;
          color: #ffffff;
          transition: background 2s;
          
        }
      }
      a:hover samp{
        background-color: rgb(238, 238, 238);
      }
      a:hover button{
        // background-color: red !important;
        background-color: #1344d8 !important;
      }
    }
  }
}
.header1{
  box-shadow:0px 5px 20px -5px rgb(235, 232, 232);
}
.router-link-exact-active {
  color: #3366ff;
}
.router-link-active {
  color: #3366ff;
}
@media screen and (max-width: 1200px) {
  .header {
    width: 1200px;
    // border: 1px solid black;
    height: 76px;
  }
}
</style>